// removed by extract-text-webpack-plugin
module.exports = {"contentContainer":"dashboard__contentContainer___2qckJ","navDrawer":"dashboard__navDrawer___3vnLt","panel":"dashboard__panel___1u-O6","nav":"dashboard__nav___2JjAn","itemContainer":"dashboard__itemContainer___3d4tE","itemContainerActive":"dashboard__itemContainerActive___3Fm15","itemIconContainer":"dashboard__itemIconContainer___2wP-Y","itemLabelContainer":"dashboard__itemLabelContainer___2S4fe","itemLabel":"dashboard__itemLabel___OETVg","bannerText":"dashboard__bannerText___stybo","statusText":"dashboard__statusText___32Vyi","greeting":"dashboard__greeting___3U8ev"};


//////////////////
// WEBPACK FOOTER
// ./study_reviewer/src/components/dashboard/dashboard.css
// module id = 1208
// module chunks = 0